<div class="scl-toast-stack" id="telekom-toast-stack">
  <!-- Toasts will be injected here via native JavaScript -->
</div>